/**
 * @generated SignedSource<<2e4d2b6635bccfc86023066a2673b96b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateQuickbooksVerificationKeyInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createQuickbooksVerificationKeyMutation$variables = {
  input: CreateQuickbooksVerificationKeyInput;
};
export type createQuickbooksVerificationKeyMutation$data = {
  readonly createQuickbooksVerificationKey: {
    readonly key: string | null;
  } | null;
};
export type createQuickbooksVerificationKeyMutation = {
  variables: createQuickbooksVerificationKeyMutation$variables;
  response: createQuickbooksVerificationKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateQuickbooksVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createQuickbooksVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createQuickbooksVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createQuickbooksVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "af4e51610a098f5e0f0614dc3b98ce19",
    "id": null,
    "metadata": {},
    "name": "createQuickbooksVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createQuickbooksVerificationKeyMutation(\n  $input: CreateQuickbooksVerificationKeyInput!\n) {\n  createQuickbooksVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();

(node as any).hash = "28ca01b35748cc020ac8b50cb99c4bed";

export default node;
